import './App.scss';

import { Suspense, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import { lazy } from 'react';

import Navbar from '../Navbar/Navbar';
import Main from '../Main/Main';
import Despre from '../Despre/Despre';
import Footer from '../Footer/Footer';
import Loader from '../Loader/Loader';

const Imprejurimi = lazy(() => import('../pages/Imprejurimi/Imprejurimi.js'));
const Camere = lazy(() => import('../pages/Camere/Camere'));
const Contact = lazy(() => import('../pages/Contact/Contact'));
const Localizare = lazy(() => import('../pages/Localizare/Localizare.js'));

function App() {
  useEffect(() => {
    //tiktok pixel
    const script = document.createElement('script');

    script.type = `text/javascript`;
    script.async = true;
    script.innerHTML = `!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


  ttq.load('D73RPEBC77UCSJRMREC0');
  ttq.page();
}(window, document, 'ttq')`;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Suspense fallback={<Fallback />}>
      <AnimatePresence>
        <Router>
          <Navbar />
          <Switch>
            <Route exact path="/">
              <Loader />
              <Main />
              <Despre />
            </Route>

            <Route path="/imprejurimi/">
              <Imprejurimi />
            </Route>

            <Route path="/camere">
              <Camere />
            </Route>

            <Route path="/contact">
              <Contact />
            </Route>

            <Route path="/localizare">
              <Localizare />
            </Route>

            <Route path="/*">
              <FourOhFour />
            </Route>
          </Switch>
          <Footer />
        </Router>
      </AnimatePresence>
    </Suspense>
  );
}

export default App;

const Fallback = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fallback"
  ></motion.div>
);

const FourOhFour = () => (
  <div className="four-o-four">
    <h1>Pagina nu există</h1>
    <Link to="/">
      <p>Înapoi la pagina principală</p>
    </Link>
  </div>
);
